import { render, staticRenderFns } from "./pharmafield.vue?vue&type=template&id=2eb2e57a&scoped=true&"
import script from "./pharmafield.vue?vue&type=script&lang=ts&"
export * from "./pharmafield.vue?vue&type=script&lang=ts&"
import style1 from "./pharmafield.vue?vue&type=style&index=1&id=2eb2e57a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb2e57a",
  null
  
)

export default component.exports